module.exports = __webpack_public_path__ + "static/media/tela-passo-01.910e66c5.jpg";